<template>
  <div :class="tipo === 'input' ? 'tipoInput' : null">
    <template v-if="tipo === 'consulta' && !displayConfirmation">
      <div class="grid fluid">
        <div class="col-12">
          <span class="p-input-icon-left">
            <i class="p-inputgroup" />
            <InputText
              :class="`input ${esCif === false && 'p-invalid'}`"
              id="idLegal"
              type="text"
              v-model="entidad.idLegal"
              :placeholder="$t('datos.placeholders.busquedaNif')"
              @blur="validarNifCif"
              @change="validarNifCif"
            />
            <small v-if="esCif === false" class="p-invalid">{{
              $t("datos.messages.error.campoIncorrecto")
            }}</small>
          </span>
        </div>
      </div>
    </template>

    <template v-else-if="tipo === 'input' && !displayConfirmation">
      <div class="grid fluid">
        <div class="col-12">
          <div class="p-inputgroup">
            <AutoComplete
              v-model="value"
              :dropdown="true"
              @dropdown-click="lookCompanyByTerm($event)"
              :suggestions="cardsCompanies"
              @complete="autocompleteByTerm($event)"
              @item-select="lookCompanyByTerm($event)"
              v-on:keyup.enter.stop="lookCompanyByTerm($event)"
              field="sugerencia"
              :minLength="3"
              :placeholder="$t('datos.placeholders.busquedaEmpresa')"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </template>

    <Dialog
      :header="$t('common.mensajes.confirmacionOpcionDeseada')"
      :visible.sync="displayConfirmation"
      :modal="true"
    >
      <div class="confirmation-content">
        <div class="grid fluid">
          <div class="col-12">
            <DataTable
              :value="cardsCompaniesTable"
              selectionMode="single"
              dataKey="#{cif}"
              @row-select="selectEntity"
              :paginator="true"
              :autoLayout="true"
              :rows="10"
              paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink "
            >
              <Column
                field="nombre"
                :header="$t('datos.label.nombreDialog')"
                bodyStyle="text-align: left"
              ></Column>
              <Column
                field="provincia"
                :header="$t('datos.label.provinciaDialog')"
                bodyStyle="text-align: left"
              ></Column>
            </DataTable>
          </div>
          <div class="col-12">
            {{ $t("datos.textos.buscadorWarning") }}
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('common.buttons.cancel')"
          icon="pi pi-times"
          class="p-button p-button-text cancelButton"
          @click="closeModal()"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="displayModalCifNoEncontrado"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :closable="true"
    >
      <template #header>
        <span>
          {{ $t("datos.header.nifConsultadoNoEncontrado") }}
        </span>
      </template>
      <div class="grid paddingLR">
        <div class="col-12">
          {{ $t("datos.textos.compruebaNifCorrecto") }}
        </div>
      </div>
    </Dialog>
  </div>
</template>  

<script>
import {
  GET_LIST_COMPANIES_MIX,
  GET_COMPANY_CARD_MIX,
  GET_SUGGESTIONS_COMPANIES_MIX,
} from "@/graphQLQueries/BusquedaQueries";
import validations from "@/utils/validations.js";
import StringsMixin from "@/utils/strings";
import { BUSCADORES } from "@/resources/constants";
import UsersMixin from "@/utils/users";

export default {
  name: "InputConsulta",
  props: ["entidad", "tipo", "tipoEntidad", "disabled"],
  mixins: [StringsMixin, UsersMixin],
  data() {
    return {
      value: "",
      displayModalCifNoEncontrado: false,
      displayConfirmation: false,
      cardsCompanies: [],
      cardsCompaniesTable: [],
      esCif: true,
      errorIdLegal: false,
    };
  },
  methods: {
    lookCompanyByTerm(event) {
      var term = "";
      this.esCif = false;
      if (event.target && event.target.value) {
        term = event.target.value.trim();
      } else if (event.value && event.value.idLegal) {
        term = event.value.idLegal.trim();
      } else if (this.value) {
        term = this.value.trim();
      } else {
        return;
      }
      this.entidad.idLegal = term;

      this.$apollo
        .query({
          query: GET_LIST_COMPANIES_MIX,
          fetchPolicy: "no-cache",
          variables: {
            request: {
              term: term,
              uuidUsuario: this.$store.state.profile.uuid,
              tipoEntidad: this.tipoEntidad,
              idioma: this.$i18n.locale,
              buscadores: this.getBuscadores(),
            },
          },
        })
        .then((companies) => {
          if (this.esCif && companies.data.listadoEmpresas.length === 0) {
            this.displayModalCifNoEncontrado = true;
            return;
          }
          if (
            companies &&
            companies.data.listadoEmpresas &&
            companies.data.listadoEmpresas.length === 0
          ) {
            this.entidad.idLegal = term;
          }
          this.createCardsCompaniesTable(companies.data.listadoEmpresas);
        })
        .catch((error) => {
          console.error(error);
          this.cardsCompaniesTable = [];
        });
    },
    validarNifCif(event) {
      var term = "";
      this.esCif = false;
      if (event.target && event.target.value && event.target.value !== this.$store.state.idLegal) {
        this.errorIdLegal = false
        this.$emit('show-error',null, this.errorIdLegal)
        term = event.target.value.trim();
        this.esCif = validations.validateNifOrCif(term);
        this.entidad.idLegal = term;
      } else {
        if(event.target.value != "") {
          this.errorIdLegal = true
          this.$emit('show-error',null, this.errorIdLegal)
          this.esCif = validations.validateNifOrCif(event.target.value.trim());
        }
      }
    },
    autocompleteByTerm(event) {
      this.$apollo
        .query({
          query: GET_SUGGESTIONS_COMPANIES_MIX,
          variables: {
            request: {
              term: event.query,
              uuidUsuario: this.$store.state.profile.uuid,
              tipoEntidad: this.tipoEntidad,
              buscadores: this.getBuscadores(),
            },
          },
        })
        .then((suggestions) => {
          if (suggestions && suggestions.data.predictivo.length === 0) {
            //Si la query no devuelve nada seteamos el idLegal
            this.entidad.idLegal = event.query;
          }
          this.cardsCompanies = suggestions.data.predictivo;
        })
        .catch(() => {
          this.cardsCompanies = [];
        });
    },
    closeModal() {
      this.displayConfirmation = false;
    },
    selectEntity(event) {
      this.$apollo
        .query({
          query: GET_COMPANY_CARD_MIX,
          variables: {
            request: {
              idLegal: event.data.idLegal,
              uuidUsuario: this.$store.state.profile.uuid,
              tipoEntidad: this.tipoEntidad,
              origenResultado: event.data.origenResultado,
              idioma: this.$i18n.locale,
            },
          },
        })
        .then((company) => {
          this.copyFromApi(this.entidad, company.data);
          this.$emit("informa:address", {
            province: company.data.fichaEmpresa.provincia,
            location: company.data.fichaEmpresa.municipio,
            postalCode: company.data.fichaEmpresa.codigoPostal,
            typeOfRoad: company.data.fichaEmpresa.tipoDireccion,
            address: company.data.fichaEmpresa.direccion,
          });
        })
        .catch((error) => {
          console.error(error);
        });
      this.displayConfirmation = false;
    },
    createCardsCompaniesTable(companies) {
      if (companies && companies.length > 0) {
        this.cardsCompaniesTable = companies;
        this.displayConfirmation = true;
      }
    },
    copyFromApi(entidad, companyData) {
      entidad.nombre = companyData.fichaEmpresa.nombre;
      entidad.apellidos = companyData.fichaEmpresa.apellidos;
      entidad.razonSocial = this.getFullName(
        companyData.fichaEmpresa.nombre,
        companyData.fichaEmpresa.apellidos
      );
      entidad.idLegal = companyData.fichaEmpresa.idLegal;
      entidad.telefono = companyData.fichaEmpresa.telefono;
      entidad.email = companyData.fichaEmpresa.email;
      entidad.tipoSociedad = companyData.fichaEmpresa.tipoSociedad;
      entidad.sectorActividad = companyData.fichaEmpresa.sectorActividad;
      entidad.codigoActividad = companyData.fichaEmpresa.codigoActividad;
      entidad.tipoVia = companyData.fichaEmpresa.tipoDireccion;
      (entidad.direccion = companyData.fichaEmpresa.direccion),
        companyData.fichaEmpresa.numero;
      entidad.localidad = companyData.fichaEmpresa.municipio;
      entidad.codigoPostal = companyData.fichaEmpresa.codigoPostal;
      entidad.provincia = companyData.fichaEmpresa.provincia;
      entidad.pais = companyData.fichaEmpresa.pais;
    },
    getBuscadores() {
      if (this.tipo === "input") {
        if (this.esEntidad(this.tipoEntidad))
          return [BUSCADORES.BUSCADOR_ICIRED, BUSCADORES.BUSCADOR_EINFORMA];
        else return [BUSCADORES.BUSCADOR_ICIRED];
      }

      if (this.tipo === "consulta") return [BUSCADORES.BUSCADOR_ICIRED];

      return [BUSCADORES.BUSCADOR_ICIRED, BUSCADORES.BUSCADOR_EINFORMA];
    },
  },
};
</script>

<style>
.tipoConsulta {
  margin: 0 auto;
  border-radius: 32px !important;
  width: 50%;
}

.tipoInput {
  width: 100%;
}
</style>

<style scoped>
.p-input-icon-left > .p-inputtext {
    padding-left: 0.7rem;
}
.p-input-icon-left {
  display: block !important;
}
</style>
